import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';

import { TaxListDataService } from 'src/app/general/taxes/list/tax-list.data';
import { TaxEditorView } from './tax-editor.view';

interface TaxEditorControllerProps {
	value: number | null;
	mode: ControlMode;
	onChanged: (value: TaxSummary) => void;
	setBusy(isBusy: boolean);
	label?: string;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
	afterLoad?: (selectedOptions: any, options: any[]) => void;
}

export class TaxEditorController extends React.Component<TaxEditorControllerProps, any> {
	protected taxListDataService: TaxListDataService;

	constructor(props) {
		super(props);
		this.taxListDataService = TaxListDataService.make();
	}

	@autobind
	protected taxQuery(q?: string): Promise<QueryResult<TaxSummary>> {
		return new Promise<QueryResult<TaxSummary>>((resolve, reject) => {
			this.props.setBusy(true);
			this.taxListDataService.addFilter('isDeleted', 'eq', false);
			this.taxListDataService.addSorting('id', 'asc', true);
			this.taxListDataService.searchKeywords = q;
			this.taxListDataService.load(query => query)
				.then((items) => {
					this.props.setBusy(false);
					resolve({
						items: items,
						totalCount: this.taxListDataService.count
					});
				});
		});
	}

	render() {
		return (
			<TaxEditorView
				taxRequest={{ query: this.taxQuery, dataSet: this.taxListDataService }}
				onChanged={this.props.onChanged}
				value={this.props.value}
				onGetErrorMessage={this.props.onGetErrorMessage}
				mode={this.props.mode}
				label={this.props.label}
				required={this.props.required}
				afterLoad={this.props.afterLoad}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/taxes/parts/tax-editor.controller.tsx